var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"dashboard-container"},[_c('v-page-title',{staticClass:"_border-bottom",attrs:{"primary":_vm.title.primary,"secondary":_vm.title.secondary}})],1),_c('v-under-construction')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }